module.exports = __webpack_public_path__ + "static/media/token.6e00a408.svg";